import React from 'react';
import { Stack, Icon, Text } from '@fluentui/react';

const StepItem = ({ label, icon, color, onClick, isClickable }) => (
  <Stack horizontalAlign="center" tokens={{ childrenGap: 4 }}
    onClick={isClickable ? onClick : undefined}
    style={{
      cursor: isClickable ? 'pointer' : 'default',
      userSelect: 'none',
    }}>
    <Icon iconName={icon} style={{ fontSize: 18, color }} />
    <Text styles={{ root: { fontSize: 12, color, marginTop: 2 } }}>{label}</Text>
  </Stack>
);

const StepProgress = ({ currentStepIndex = 0, onClickStepIndex }) => {
  const activeColor = '#0078d4';
  const inactiveColor = '#ccc';

  const baseSteps = [
    { label: 'Reviewing', defaultIcon: 'SkypeCircleCheck' },
    { label: 'Attesting', defaultIcon: 'RadioBtnOn' },
    { label: 'Action', defaultIcon: 'LockSolid' },
  ];

  const steps = baseSteps.map((step, index) => {
    let color = inactiveColor;
    let icon = step.defaultIcon;

    if (currentStepIndex === 0) {
      if (index <= 1) color = activeColor;
      if (index === 0) icon = 'SkypeCircleCheck';
      if (index === 1) icon = 'RadioBtnOn';
      if (index === 2) icon = 'LockSolid';
    } else if (currentStepIndex === 1) {
      color = activeColor;
      if (index === 0) icon = 'SkypeCircleCheck';
      if (index === 1) icon = 'SkypeCircleCheck';
      if (index === 2) icon = 'RadioBtnOn';
    } else if (currentStepIndex >= 2) {
      color = activeColor;
      icon = 'SkypeCircleCheck';
    }

    return { ...step, color, icon };
  });

  return (
    <Stack horizontal verticalAlign="center" horizontalAlign="center" styles={{ root: { paddingTop: 0 } }}>
      {steps.map((step, index) => {
        var isClickable = step.icon === 'SkypeCircleCheck';
        if (index == 0 || currentStepIndex == 2) {
          isClickable = false;
        }
        return (
          <React.Fragment key={index}>
            <StepItem
              {...step}
              isClickable={isClickable}
              onClick={() => {
                if (isClickable && onClickStepIndex && index != 0) {
                  onClickStepIndex(index);
                }
              }}
            />
            {index < steps.length - 1 && (
              <div
                style={{
                  flexShrink: 0,
                  width: 40,
                  height: 2,
                  backgroundColor:
                    (currentStepIndex === 0 && index === 0) ||
                      (currentStepIndex === 1) ||
                      (currentStepIndex >= 2)
                      ? '#0078d4' : '#ccc',
                  margin: '0 20px',
                  alignSelf: 'center'
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Stack>
  );
};

export default StepProgress;
